/* App Variables */
window.base_url     = jQuery("body").attr("data-base");
window.template_url = base_url+'/wp-content/themes/mococa';
window.app_width    = 1024;
window.app_margin   = 24;

jQuery(document).ready(function($) {
	
	var app_header = $(".app-header");
	var app_section = $(".app-section");

	/* App Header - BEGIN */
		function appHeader_height()
		{
			var header_h = app_header.outerHeight();

			app_section.css('padding-top', header_h);
			$("body").find(".menu-section").css('top', header_h);
		}
	/* App Header - END */

	/* Menu Section - BEGIN */

		/**/
		$("body").on('click', '.menu-section .close, .menu-section .menu-item > a', function(event) {
			$(".menu-section").removeClass('open');

			setTimeout(function() {
				$(".menu-section").removeClass('active');
			}, 100);
		});

		/**/
		$("body").on('mouseover', 'ul.depth_0.show>li', function(event) {
			var item = $(this).find('a[data-object="product_category"]');
			var image_container = $(this).find('.menu-product-image');
			var image = $(this).find('.menu-product-image img');
			
			if ( image.attr('src') !== item.attr('data-cf-image') ){
				image_container.html('');
				image_container.css('background-image', 'url('+((item.attr('data-cf-background')) ? item.attr('data-cf-background') : '')+')');
				image_container.fadeIn(300);
				image_container.html((item.attr('data-cf-image')) ? '<img data-aos="fade-left" data-aos-duration="700" data-aos-delay="250" src="'+item.attr('data-cf-image')+'">' : '');
			}
		});
		$("body").on('mouseout', 'ul.depth_0.show>li', function(event) {
			var item = $(this).find('a[data-object="product_category"]');
			var image_container = $(this).find('.menu-product-image');
			var image = $(this).find('.menu-product-image img');

			image_container.html('');
		});

		/**/
		$("body").on('mouseover', '.menu-section a[data-object="recipe_category"]', function(event) {
			var item      = $(this);
			var item_data = JSON.parse(item.attr('data-recipe'));
			var image     = $('body').find('.menu-section .image');

			if(item_data && item_data.name){
				var item_info = '';

				/**/
				if(item_data.difficulty){ item_info += '<div class="info-difficulty"><span title="'+item_data.difficulty.name+'"><img alt="'+item_data.difficulty.name+'" src="'+item_data.difficulty.icon+'"></span></div>'; }

				/**/
				if(item_data.time){ item_info += '<div class="info-time"><span title="'+item_data.time.name+'"><img alt="'+item_data.time.name+'" src="'+item_data.time.icon+'">'+item_data.time.name+'</span></div>'; }

				/**/
				if(item_data.categories){
					for (var c = 0; c < item_data.categories.length; c++) {
						var category = item_data.categories[c];

						item_info += '<div class="info-category"><span title="'+category.name+'"><img alt="'+category.name+'" src="'+category.icon+'"></span></div>';
					}
				}

				/**/
				image.css('background-image', 'url('+((item_data.thumbnail) ? item_data.thumbnail : '')+')').html(`
					<a href="`+item_data.permalink+`" target="_self" title="`+item_data.name+`" class="recipe">
						<div>
							<h1>`+item_data.name+`</h1>

							<div class="info">`+item_info+`</div>
						</div>
					</a>
				`);
			}
		});
	/* Menu Section - END */
});

(function(){
	AOS.init();

	const nav_menu_toggle = document.querySelector('.navbar-toggler');
	const header_site = document.querySelector('.app-header');

	nav_menu_toggle.addEventListener( 'click', (e) => {
		e.preventDefault();
		header_site.classList.toggle( 'bg-primary' );
	} );
})();
